var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUbpd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 217.471,
    height: 35.949,
    viewBox: "0 0 217.471 35.949",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1416",
    "data-name": "Group 1416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1412",
    "data-name": "Group 1412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1409",
    "data-name": "Group 1409"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4142",
    "data-name": "Path 4142",
    d: "M25.819,20.921c-.627-.891-1.179-1.707-1.765-2.474a17.551,17.551,0,0,0-7.126-6.013c-1.592-.668-3.3-1.113-4.949-1.65A50.188,50.188,0,0,1,4.523,7.948a8.619,8.619,0,0,1-4.1-3.827c-.049-.132-.1-.239-.14-.346-.124-.313-.132-.668.19-.825a1.08,1.08,0,0,1,.825,0c.825.47,1.592,1.056,2.474,1.5a15.135,15.135,0,0,0,5.5,1.592A28.043,28.043,0,0,0,15.1,5.927a2.623,2.623,0,0,0,1.113-.421.561.561,0,0,0-.049-1.047A11.431,11.431,0,0,0,14.766,3.9a5.386,5.386,0,0,1-2.293-1.427A5.46,5.46,0,0,1,11.583.937a1.006,1.006,0,0,1,.223-.825c.239-.272.52-.066.767.124A16.083,16.083,0,0,0,16.63,2.141c1.905.726,3.868,1.336,5.683,2.235A8.5,8.5,0,0,1,27.2,12a24.744,24.744,0,0,1-1,7.58C26.082,20,25.959,20.418,25.819,20.921Z",
    transform: "translate(-0.036 0.019)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4143",
    "data-name": "Path 4143",
    d: "M13.807,13.868a1.691,1.691,0,0,1-.305.091,26.558,26.558,0,0,1-7.868-.586A8.718,8.718,0,0,1,.825,10.321,3.5,3.5,0,0,1,0,8.292a1.864,1.864,0,0,1,.181-.6,1.732,1.732,0,0,1,.577.256,15.951,15.951,0,0,0,5.46,3.646c2.194.775,4.446,1.377,6.673,2.054C13.2,13.719,13.411,13.76,13.807,13.868Z",
    transform: "translate(0 -1.332)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4144",
    "data-name": "Path 4144",
    d: "M8.522,15.618c-2.474.635-4.8.544-6.829-1.163A6.029,6.029,0,0,1,.653,13.07c-.074-.115,0-.346.066-.52.173,0,.4,0,.511.124a11.691,11.691,0,0,0,6.722,2.854Z",
    transform: "translate(-0.109 -2.183)",
    fill: "#7e739a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1410",
    "data-name": "Group 1410",
    transform: "translate(33.398 0.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4145",
    "data-name": "Path 4145",
    d: "M41.835,20.867c-.305-1.3-.635-2.59-.907-3.9a17.428,17.428,0,0,1-.322-5.848,8.693,8.693,0,0,1,5.642-7.159c2-.825,4.074-1.485,6.087-2.293C53.349,1.253,54.281.659,55.262.173c.173-.082.487-.132.6,0a.825.825,0,0,1,.289.643,3.043,3.043,0,0,1-1.089,1.9A7.53,7.53,0,0,1,52.293,4.14a3.184,3.184,0,0,0-.668.28c-.561.322-.586.825,0,1.171a2.2,2.2,0,0,0,.825.33,25.972,25.972,0,0,0,7.423-.049,14.261,14.261,0,0,0,6.483-2.813.7.7,0,0,1,.949-.082.668.668,0,0,1,.14.883,7.86,7.86,0,0,1-3.3,3.588,23.845,23.845,0,0,1-5.237,2.285c-2.219.726-4.454,1.377-6.664,2.12a17.164,17.164,0,0,0-8.075,6c-.635.825-1.212,1.65-1.823,2.524-.115.165-.231.338-.338.511Z",
    transform: "translate(-40.493 -0.091)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4146",
    "data-name": "Path 4146",
    d: "M56.74,13.878l4.594-1.245a18.78,18.78,0,0,0,8.4-4.685,1.806,1.806,0,0,1,.619-.247,2.012,2.012,0,0,1,.157.668,4.809,4.809,0,0,1-1.74,2.944,9.79,9.79,0,0,1-5.279,2.408,30.055,30.055,0,0,1-6.532.247Z",
    transform: "translate(-43.34 -1.424)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4147",
    "data-name": "Path 4147",
    d: "M63.14,15.676c1.08-.223,2.07-.4,3.035-.643a9.6,9.6,0,0,0,4.272-2.293c.132-.124.388-.132.577-.19,0,.223.091.478,0,.652A4.578,4.578,0,0,1,68.6,15.4,8.289,8.289,0,0,1,63.14,15.676Z",
    transform: "translate(-44.461 -2.274)",
    fill: "#7e739a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4148",
    "data-name": "Path 4148",
    d: "M34.23,25.641a3.942,3.942,0,0,0,4.025,0l-1.74-5.963s-.19-.973-.379,0S34.23,25.641,34.23,25.641Z",
    transform: "translate(-5.998 -3.356)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_220",
    "data-name": "Ellipse 220",
    cx: 2.598,
    cy: 2.598,
    r: 2.598,
    transform: "translate(27.507 2.35)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1411",
    "data-name": "Group 1411",
    transform: "translate(12.76 26.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4149",
    "data-name": "Path 4149",
    d: "M17.878,32.11v5.773a2.186,2.186,0,0,0,.181.759,1.245,1.245,0,0,0,.478.553,1.716,1.716,0,0,0,.924.214,1.65,1.65,0,0,0,.916-.214,1.287,1.287,0,0,0,.478-.553,2.235,2.235,0,0,0,.19-.759V32.11h2.375v5.32a4.289,4.289,0,0,1-.916,3.126,4.074,4.074,0,0,1-3.01.99,4.124,4.124,0,0,1-3.019-.99,4.272,4.272,0,0,1-.99-3.126V32.11Z",
    transform: "translate(-15.47 -32.104)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4150",
    "data-name": "Path 4150",
    d: "M27.53,32.117s1.971-.049,4.462.041a2.062,2.062,0,0,1,2.161,2.227,1.889,1.889,0,0,1-1.493,1.946,2.8,2.8,0,0,1,.874.305,1.839,1.839,0,0,1,.586.5,1.93,1.93,0,0,1,.322.668,3.06,3.06,0,0,1,.074.808,2.87,2.87,0,0,1-.223,1.163,2.326,2.326,0,0,1-.635.825,2.7,2.7,0,0,1-.99.52,4.594,4.594,0,0,1-1.311.173H27.546v-9.18Zm2.392,3.53h1.229c.462,0,.718-.6.718-.874a.757.757,0,0,0-.718-.874,9.539,9.539,0,0,0-1.229,0Zm0,3.819h1.5c.561,0,.883-.668.883-.973a.825.825,0,0,0-.883-.973h-1.5Z",
    transform: "translate(-17.583 -32.103)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4151",
    "data-name": "Path 4151",
    d: "M40.134,41.289H37.75v-9.18h3.8a3.241,3.241,0,0,1,2.367.825,3.052,3.052,0,0,1,.825,2.268,3.019,3.019,0,0,1-.825,2.268,3.241,3.241,0,0,1-2.367.825h-1.41v3.043Zm0-4.949h.825c.874,0,1.311-.379,1.311-1.146s-.437-1.146-1.311-1.146h-.825Z",
    transform: "translate(-19.374 -32.103)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4152",
    "data-name": "Path 4152",
    d: "M47.758,32.11h3.5a4.074,4.074,0,0,1,1.757.379A4.792,4.792,0,0,1,54.447,33.5a4.594,4.594,0,0,1,.965,1.46,4.363,4.363,0,0,1,.355,1.749,4.446,4.446,0,0,1-.346,1.732,4.635,4.635,0,0,1-.965,1.468,4.949,4.949,0,0,1-1.435,1.014,4.124,4.124,0,0,1-1.773.379h-3.5V32.11Zm2.384,7.159h.544a2.9,2.9,0,0,0,1.105-.2,2.384,2.384,0,0,0,.825-.536,2.293,2.293,0,0,0,.511-.825,2.936,2.936,0,0,0,.173-1.031,2.78,2.78,0,0,0-.181-1.023,2.474,2.474,0,0,0-.52-.825,2.309,2.309,0,0,0-.825-.536,2.887,2.887,0,0,0-1.1-.2h-.544v5.147Z",
    transform: "translate(-21.126 -32.104)",
    fill: "#7e739a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1415",
    "data-name": "Group 1415",
    transform: "translate(69.381 6.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1413",
    "data-name": "Group 1413",
    transform: "translate(0.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4153",
    "data-name": "Path 4153",
    d: "M85.606,12.53v5.905a3.3,3.3,0,0,0,.412,1.848,2.21,2.21,0,0,0,3.472,0,3.217,3.217,0,0,0,.412-1.848V12.53h1.476v6.31a3.522,3.522,0,0,1-.965,2.549,3.736,3.736,0,0,1-5.32,0,3.522,3.522,0,0,1-.965-2.549V12.53Z",
    transform: "translate(-84.127 -9)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4154",
    "data-name": "Path 4154",
    d: "M95.77,22.187V11.72l7.151,7.481V12.388H104.4v10.4l-7.151-7.423v6.862H95.77Z",
    transform: "translate(-86.167 -8.858)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4155",
    "data-name": "Path 4155",
    d: "M110.556,12.53v9.8H109.08v-9.8Z",
    transform: "translate(-88.499 -9)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4156",
    "data-name": "Path 4156",
    d: "M113.72,22.328v-9.8h2.054a7.613,7.613,0,0,1,2.334.289,4.289,4.289,0,0,1,1.65.973,4.685,4.685,0,0,1,1.518,3.637,4.775,4.775,0,0,1-3.2,4.627,7.6,7.6,0,0,1-2.3.272Zm1.485-1.386h.668a5.567,5.567,0,0,0,1.65-.206,3.34,3.34,0,0,0,2.285-3.3,3.415,3.415,0,0,0-1.08-2.615,4.124,4.124,0,0,0-2.862-.9H115.2v7.019Z",
    transform: "translate(-89.312 -8.999)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4157",
    "data-name": "Path 4157",
    d: "M130.1,19.823h-4.2l-1.089,2.384H123.22l4.85-10.417,4.677,10.417H131.1Zm-.6-1.394-1.452-3.3-1.526,3.3Z",
    transform: "translate(-90.977 -8.87)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4158",
    "data-name": "Path 4158",
    d: "M136.26,22.328v-9.8h2.054a7.613,7.613,0,0,1,2.334.289,4.289,4.289,0,0,1,1.65.973,4.685,4.685,0,0,1,1.518,3.637,4.776,4.776,0,0,1-3.25,4.627,7.6,7.6,0,0,1-2.3.272Zm1.476-1.386h.668a5.534,5.534,0,0,0,1.65-.206,3.34,3.34,0,0,0,2.285-3.3,3.415,3.415,0,0,0-1.08-2.615,4.124,4.124,0,0,0-2.862-.9h-.668v7.019Z",
    transform: "translate(-93.262 -8.999)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4159",
    "data-name": "Path 4159",
    d: "M152.57,22.328v-9.8h2.054a7.613,7.613,0,0,1,2.334.289,4.289,4.289,0,0,1,1.65.973,4.685,4.685,0,0,1,1.518,3.637,4.775,4.775,0,0,1-3.25,4.627,7.6,7.6,0,0,1-2.3.272Zm1.476-1.386h.668a5.567,5.567,0,0,0,1.65-.206,3.34,3.34,0,0,0,2.285-3.3,3.415,3.415,0,0,0-1.08-2.615,4.124,4.124,0,0,0-2.862-.9h-.668v7.019Z",
    transform: "translate(-96.119 -8.999)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4160",
    "data-name": "Path 4160",
    d: "M169.419,13.916h-3.926v2.359h3.819v1.394h-3.819v3.3h3.926v1.394H164V12.53h5.411Z",
    transform: "translate(-98.122 -9)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4161",
    "data-name": "Path 4161",
    d: "M177.79,22.328v-9.8h1.476a6.6,6.6,0,0,1,1.567.148,2.342,2.342,0,0,1,1,.511,2.631,2.631,0,0,1,.652.932,2.845,2.845,0,0,1,.247,1.146,2.318,2.318,0,0,1-.825,1.782,2.367,2.367,0,0,1,1.229.932,2.763,2.763,0,0,1-.363,3.481,2.623,2.623,0,0,1-1.1.676,6.334,6.334,0,0,1-1.65.181H177.79Zm1.476-5.592h.462a1.732,1.732,0,0,0,1.212-.363,1.419,1.419,0,0,0,.388-1.072,1.336,1.336,0,0,0-.4-1.047,1.65,1.65,0,0,0-1.146-.355h-.52Zm0,4.206h.916a2.276,2.276,0,0,0,1.476-.4,1.427,1.427,0,0,0,0-2.144,2.474,2.474,0,0,0-1.65-.429h-.751Z",
    transform: "translate(-100.538 -8.999)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4162",
    "data-name": "Path 4162",
    d: "M188.586,11.78v5.905A3.3,3.3,0,0,0,189,19.533a2.21,2.21,0,0,0,3.472,0,3.217,3.217,0,0,0,.412-1.848V11.78h1.476v6.31a3.522,3.522,0,0,1-.965,2.549,3.736,3.736,0,0,1-5.32,0,3.522,3.522,0,0,1-.965-2.549V11.78Zm4.4-2.639-2.59,1.749-.7-.594,2.037-2.045Z",
    transform: "translate(-102.171 -8.25)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4163",
    "data-name": "Path 4163",
    d: "M204.2,13.958l-1.2.709a2,2,0,0,0-.643-.759,1.7,1.7,0,0,0-1.839.14,1.089,1.089,0,0,0-.4.866c0,.478.355.866,1.064,1.155l.981.4a4.247,4.247,0,0,1,1.749,1.179,2.639,2.639,0,0,1,.553,1.707,2.986,2.986,0,0,1-.9,2.235,3.076,3.076,0,0,1-2.227.891,3.01,3.01,0,0,1-2.1-.759,3.464,3.464,0,0,1-1.023-2.128l1.5-.33a2.6,2.6,0,0,0,.355,1.2,1.691,1.691,0,0,0,2.474.173,1.592,1.592,0,0,0,.445-1.146,1.576,1.576,0,0,0-.082-.528,1.221,1.221,0,0,0-.247-.437,1.988,1.988,0,0,0-.437-.371,3.786,3.786,0,0,0-.635-.33l-.949-.4c-1.344-.569-2.012-1.394-2.012-2.474a2.367,2.367,0,0,1,.825-1.848,3.027,3.027,0,0,1,2.1-.751,2.92,2.92,0,0,1,2.648,1.608Z",
    transform: "translate(-104.116 -8.968)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4164",
    "data-name": "Path 4164",
    d: "M217.776,22.471h-1.864l-.767-.784a4.949,4.949,0,0,1-2.73.784,5.081,5.081,0,0,1-3.456-1.32,4.726,4.726,0,0,1-1.65-3.712,4.891,4.891,0,0,1,1.559-3.7,5.006,5.006,0,0,1,3.571-1.435,5.064,5.064,0,0,1,3.349,1.254,4.949,4.949,0,0,1,1.782,3.942,4.776,4.776,0,0,1-1.4,3.382Zm-4.066-4.058,1.419,1.419a3.357,3.357,0,0,0,1-2.417,3.613,3.613,0,0,0-1.048-2.648A3.514,3.514,0,0,0,212.44,13.7a3.423,3.423,0,0,0-2.59,1.064,3.7,3.7,0,0,0-1.023,2.689,3.456,3.456,0,0,0,1.056,2.6,3.547,3.547,0,0,0,2.474,1.039,3.489,3.489,0,0,0,1.732-.437l-2.3-2.235H213.7Z",
    transform: "translate(-105.71 -8.961)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4165",
    "data-name": "Path 4165",
    d: "M223.5,12.53v5.905a3.3,3.3,0,0,0,.412,1.848,2.21,2.21,0,0,0,3.472,0,3.217,3.217,0,0,0,.412-1.848V12.53h1.476v6.31a3.522,3.522,0,0,1-.965,2.549,3.745,3.745,0,0,1-5.328,0A3.522,3.522,0,0,1,222,18.84V12.53Z",
    transform: "translate(-108.284 -9)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4166",
    "data-name": "Path 4166",
    d: "M239.081,13.916h-3.926v2.359h3.819v1.394h-3.819v3.3h3.926v1.394H233.67V12.53h5.411Z",
    transform: "translate(-110.329 -9)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4167",
    "data-name": "Path 4167",
    d: "M242.58,22.328v-9.8h2.054a7.613,7.613,0,0,1,2.334.289,4.289,4.289,0,0,1,1.65.973,4.685,4.685,0,0,1,1.518,3.637,4.776,4.776,0,0,1-3.25,4.627,7.6,7.6,0,0,1-2.3.272Zm1.485-1.386h.668a5.567,5.567,0,0,0,1.65-.206,3.34,3.34,0,0,0,2.285-3.3,3.415,3.415,0,0,0-1.08-2.615,4.124,4.124,0,0,0-2.862-.9h-.668v7.019Z",
    transform: "translate(-111.891 -8.999)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4168",
    "data-name": "Path 4168",
    d: "M258.957,19.823h-4.2l-1.1,2.384H252.07l4.891-10.417,4.677,10.417h-1.65Zm-.6-1.394-1.452-3.3-1.526,3.3Z",
    transform: "translate(-113.553 -8.87)",
    fill: "#7e739a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1414",
    "data-name": "Group 1414",
    transform: "translate(0 16.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4169",
    "data-name": "Path 4169",
    d: "M84.12,33.783V28.529h1.105a3.934,3.934,0,0,1,1.254.157,2.309,2.309,0,0,1,.9.52A2.516,2.516,0,0,1,88.2,31.16a2.557,2.557,0,0,1-1.74,2.474,3.992,3.992,0,0,1-1.237.148Zm.825-.751H85.3a3.035,3.035,0,0,0,.891-.115,1.9,1.9,0,0,0,.643-.379,1.971,1.971,0,0,0,0-2.8,2.177,2.177,0,0,0-1.534-.478h-.355v3.778Z",
    transform: "translate(-84.12 -28.167)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4170",
    "data-name": "Path 4170",
    d: "M93.163,29.271H91.052v1.295H93.1v.742H91.052V33.04h2.111v.742h-2.9V28.52h2.9Z",
    transform: "translate(-85.196 -28.165)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4171",
    "data-name": "Path 4171",
    d: "M98.435,31.647v2.136H97.61V28.53h.9a4.264,4.264,0,0,1,1,.091,1.27,1.27,0,0,1,.6.346,1.485,1.485,0,0,1,.454,1.113,1.452,1.452,0,0,1-.487,1.146,1.922,1.922,0,0,1-1.3.421Zm0-.734h.322c.726,0,1.1-.28,1.1-.825s-.379-.825-1.13-.825H98.46Z",
    transform: "translate(-86.484 -28.167)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4172",
    "data-name": "Path 4172",
    d: "M105.113,29.271h-2.1v1.295h2.045v.742H103.01V33.04h2.1v.742h-2.9V28.52h2.9Z",
    transform: "translate(-87.29 -28.165)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4173",
    "data-name": "Path 4173",
    d: "M108.773,31.538l1.65,2.243h-.973l-1.493-2.153h-.132v2.153H107V28.528h.932a2.342,2.342,0,0,1,1.542.388,1.452,1.452,0,0,1,.511,1.155,1.476,1.476,0,0,1-.322.957A1.435,1.435,0,0,1,108.773,31.538Zm-.949-.6h.256c.751,0,1.13-.289,1.13-.825s-.363-.825-1.1-.825h-.289Z",
    transform: "translate(-88.129 -28.165)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4174",
    "data-name": "Path 4174",
    d: "M115,29.288l-.643.379a1.138,1.138,0,0,0-.346-.412.9.9,0,0,0-.982.082.577.577,0,0,0-.214.462q0,.379.569.619l.528.214a2.186,2.186,0,0,1,.94.635,1.419,1.419,0,0,1,.3.916,1.6,1.6,0,0,1-.487,1.2,1.779,1.779,0,0,1-2.342.074,1.814,1.814,0,0,1-.544-1.138l.825-.173a1.385,1.385,0,0,0,.19.643.877.877,0,0,0,1.584-.536,1,1,0,0,0-.041-.28.643.643,0,0,0-.132-.231.916.916,0,0,0-.231-.2,2.145,2.145,0,0,0-.363-.165l-.5-.214a1.468,1.468,0,0,1-1.08-1.336,1.254,1.254,0,0,1,.454-.99,1.65,1.65,0,0,1,1.13-.4A1.551,1.551,0,0,1,115,29.288Z",
    transform: "translate(-88.966 -28.149)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4175",
    "data-name": "Path 4175",
    d: "M116.7,31.1a2.557,2.557,0,0,1,.825-1.905,2.7,2.7,0,0,1,1.947-.825,2.747,2.747,0,0,1,2.738,2.73,2.59,2.59,0,0,1-.825,1.922,2.788,2.788,0,0,1-3.794.091A2.54,2.54,0,0,1,116.7,31.1Zm.825,0a1.955,1.955,0,0,0,3.324,1.435,2.045,2.045,0,0,0,0-2.821,1.856,1.856,0,0,0-1.386-.569,1.889,1.889,0,0,0-1.386.569,1.914,1.914,0,0,0-.577,1.394Z",
    transform: "translate(-89.828 -28.139)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4176",
    "data-name": "Path 4176",
    d: "M124.57,33.707V28.09l3.835,4.05v-3.7h.825V34.02l-3.835-4V33.7h-.825Z",
    transform: "translate(-91.207 -28.09)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4177",
    "data-name": "Path 4177",
    d: "M134.722,32.435H132.47l-.586,1.278h-.825l2.6-5.584,2.474,5.584h-.866Zm-.322-.742-.825-1.79-.825,1.79Z",
    transform: "translate(-92.345 -28.097)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4178",
    "data-name": "Path 4178",
    d: "M140.933,29.284l-.643.379a1.138,1.138,0,0,0-.346-.412.907.907,0,0,0-.981.082.577.577,0,0,0-.214.462q0,.379.569.619l.528.214a2.112,2.112,0,0,1,.932.635,1.419,1.419,0,0,1,.3.916,1.6,1.6,0,0,1-.487,1.2,1.779,1.779,0,0,1-2.342.074,1.815,1.815,0,0,1-.544-1.138l.825-.173a1.385,1.385,0,0,0,.19.643.877.877,0,0,0,1.584-.536,1,1,0,0,0,0-.28.643.643,0,0,0-.132-.231.915.915,0,0,0-.231-.2,2.144,2.144,0,0,0-.338-.181l-.511-.214a1.468,1.468,0,0,1-1.138-1.336,1.254,1.254,0,0,1,.454-.99,1.649,1.649,0,0,1,1.13-.4,1.551,1.551,0,0,1,1.4.874Z",
    transform: "translate(-93.508 -28.146)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4179",
    "data-name": "Path 4179",
    d: "M145.56,33.783V28.529h1.105a3.934,3.934,0,0,1,1.254.157,2.309,2.309,0,0,1,.9.52,2.516,2.516,0,0,1,.825,1.955,2.557,2.557,0,0,1-1.74,2.474,3.992,3.992,0,0,1-1.237.148h-1.1Zm.825-.751h.363a3.035,3.035,0,0,0,.891-.115,1.9,1.9,0,0,0,.643-.379,1.971,1.971,0,0,0,0-2.8,2.177,2.177,0,0,0-1.534-.478h-.355v3.778Z",
    transform: "translate(-94.885 -28.167)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4180",
    "data-name": "Path 4180",
    d: "M154.342,32.435H152.09l-.586,1.278h-.825l2.6-5.584,2.474,5.584h-.866Zm-.322-.742-.784-1.79-.825,1.79Z",
    transform: "translate(-95.782 -28.097)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4181",
    "data-name": "Path 4181",
    d: "M157.64,33.783V28.529h1.122a3.934,3.934,0,0,1,1.254.157,2.309,2.309,0,0,1,.9.52,2.516,2.516,0,0,1,.825,1.955A2.557,2.557,0,0,1,160,33.635a3.992,3.992,0,0,1-1.237.148h-1.1Zm.825-.751h.3a3.035,3.035,0,0,0,.891-.115,1.9,1.9,0,0,0,.643-.379,1.971,1.971,0,0,0,0-2.8,2.178,2.178,0,0,0-1.534-.478h-.355v3.778Z",
    transform: "translate(-97.002 -28.167)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4182",
    "data-name": "Path 4182",
    d: "M166.432,32.435H164.18l-.586,1.278h-.825l2.6-5.584,2.474,5.584h-.825Zm-.322-.742-.784-1.79-.825,1.79Z",
    transform: "translate(-97.901 -28.097)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4183",
    "data-name": "Path 4183",
    d: "M172.645,29.284l-.643.379a1.139,1.139,0,0,0-.346-.412.907.907,0,0,0-.981.082.577.577,0,0,0-.214.462q0,.379.569.619l.528.214a2.186,2.186,0,0,1,.94.635,1.419,1.419,0,0,1,.3.916,1.6,1.6,0,0,1-.487,1.2,1.779,1.779,0,0,1-2.342.074,1.815,1.815,0,0,1-.544-1.138l.825-.173a1.385,1.385,0,0,0,.19.643.877.877,0,0,0,1.584-.536,1,1,0,0,0,0-.28.643.643,0,0,0-.132-.231.916.916,0,0,0-.231-.2,2.146,2.146,0,0,0-.338-.181l-.5-.214a1.468,1.468,0,0,1-1.081-1.336,1.254,1.254,0,0,1,.454-.99,1.65,1.65,0,0,1,1.13-.4A1.542,1.542,0,0,1,172.645,29.284Z",
    transform: "translate(-99.066 -28.146)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4184",
    "data-name": "Path 4184",
    d: "M178.055,31.647v2.136h-.825V28.53h.9a4.264,4.264,0,0,1,1,.091,1.27,1.27,0,0,1,.6.346,1.485,1.485,0,0,1,.454,1.113,1.452,1.452,0,0,1-.487,1.146,1.922,1.922,0,0,1-1.3.421Zm0-.734h.3q1.089,0,1.089-.825c0-.544-.379-.825-1.13-.825h-.264v1.65Z",
    transform: "translate(-100.434 -28.167)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4185",
    "data-name": "Path 4185",
    d: "M181.51,31.1a2.557,2.557,0,0,1,.825-1.905,2.681,2.681,0,0,1,1.946-.825,2.747,2.747,0,0,1,2.738,2.73,2.59,2.59,0,0,1-.825,1.922,2.788,2.788,0,0,1-3.794.091,2.54,2.54,0,0,1-.891-2.012Zm.825,0a1.955,1.955,0,0,0,3.324,1.435,2.046,2.046,0,0,0,0-2.821,1.856,1.856,0,0,0-1.386-.569,1.889,1.889,0,0,0-1.386.569,1.914,1.914,0,0,0-.577,1.394Z",
    transform: "translate(-101.184 -28.139)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4186",
    "data-name": "Path 4186",
    d: "M191.17,31.539l1.65,2.243h-.973l-1.5-2.153h-.14v2.153h-.825V28.528h.932a2.342,2.342,0,0,1,1.5.388,1.452,1.452,0,0,1,.511,1.155,1.476,1.476,0,0,1-.322.957A1.443,1.443,0,0,1,191.17,31.539Zm-.99-.6h.256c.751,0,1.13-.289,1.13-.825s-.363-.825-1.1-.825h-.28v1.65Z",
    transform: "translate(-102.563 -28.165)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4187",
    "data-name": "Path 4187",
    d: "M197.09,33.783V28.529H198.2a3.934,3.934,0,0,1,1.254.157,2.309,2.309,0,0,1,.9.52,2.516,2.516,0,0,1,.825,1.955,2.557,2.557,0,0,1-1.74,2.474,3.992,3.992,0,0,1-1.237.148h-1.1Zm.825-.751h.355a3.035,3.035,0,0,0,.891-.115,1.9,1.9,0,0,0,.643-.379,1.971,1.971,0,0,0,0-2.8,2.177,2.177,0,0,0-1.534-.478h-.355v3.778Z",
    transform: "translate(-103.914 -28.167)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4188",
    "data-name": "Path 4188",
    d: "M206.123,29.271h-2.111v1.295h2.045v.742h-2.045V33.04h2.111v.742h-2.9V28.52h2.9Z",
    transform: "translate(-104.988 -28.165)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4189",
    "data-name": "Path 4189",
    d: "M210.925,29.284l-.643.379a1.138,1.138,0,0,0-.346-.412.907.907,0,0,0-.981.082.577.577,0,0,0-.214.462q0,.379.569.619l.528.214a2.185,2.185,0,0,1,.94.635,1.419,1.419,0,0,1,.3.916,1.6,1.6,0,0,1-.487,1.2,1.779,1.779,0,0,1-2.342.074,1.856,1.856,0,0,1-.544-1.138l.825-.173a1.385,1.385,0,0,0,.19.643.877.877,0,0,0,1.584-.536,1,1,0,0,0,0-.28.644.644,0,0,0-.132-.231.914.914,0,0,0-.231-.2,2.144,2.144,0,0,0-.338-.181l-.5-.214a1.468,1.468,0,0,1-1.146-1.336,1.254,1.254,0,0,1,.454-.99,1.65,1.65,0,0,1,1.13-.4A1.559,1.559,0,0,1,210.925,29.284Z",
    transform: "translate(-105.773 -28.146)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4190",
    "data-name": "Path 4190",
    d: "M215.832,32.435H213.58l-.586,1.278h-.825l2.6-5.584,2.474,5.584h-.825Zm-.322-.742-.784-1.79-.825,1.79Z",
    transform: "translate(-106.556 -28.097)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4191",
    "data-name": "Path 4191",
    d: "M219.915,31.647v2.136h-.825V28.53h.9a4.264,4.264,0,0,1,1,.091,1.27,1.27,0,0,1,.6.346,1.485,1.485,0,0,1,.454,1.113,1.452,1.452,0,0,1-.487,1.146,1.922,1.922,0,0,1-1.3.421Zm0-.734h.3q1.089,0,1.089-.825c0-.544-.379-.825-1.13-.825h-.264v1.65Z",
    transform: "translate(-107.769 -28.167)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4192",
    "data-name": "Path 4192",
    d: "M226.222,32.435H223.97l-.586,1.278h-.825l2.6-5.584,2.474,5.584h-.866Zm-.322-.742-.825-1.79-.825,1.79Z",
    transform: "translate(-108.377 -28.097)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4193",
    "data-name": "Path 4193",
    d: "M231.27,31.539l1.65,2.243h-.973l-1.5-2.153h-.14v2.153h-.825V28.528h.932a2.342,2.342,0,0,1,1.5.388,1.452,1.452,0,0,1,.511,1.155,1.476,1.476,0,0,1-.322.957,1.443,1.443,0,0,1-.833.511Zm-.99-.6h.256c.751,0,1.13-.289,1.13-.825s-.363-.825-1.1-.825h-.28v1.65Z",
    transform: "translate(-109.589 -28.165)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4194",
    "data-name": "Path 4194",
    d: "M237.48,29.271h-2.111v1.295H237.4v.742h-2.045V33.04h2.111v.742h-2.9V28.52h2.9Z",
    transform: "translate(-110.479 -28.165)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4195",
    "data-name": "Path 4195",
    d: "M243.182,28.779v.932a2.186,2.186,0,0,0-1.427-.577,1.823,1.823,0,0,0-1.369.586,1.971,1.971,0,0,0-.561,1.419,1.914,1.914,0,0,0,.561,1.394,1.839,1.839,0,0,0,1.369.569,1.65,1.65,0,0,0,.709-.14,2.738,2.738,0,0,0,.338-.181,4.4,4.4,0,0,0,.371-.28v.957a2.879,2.879,0,0,1-1.427.388,2.648,2.648,0,0,1-1.922-.825A2.606,2.606,0,0,1,239,31.1a2.714,2.714,0,0,1,.66-1.79,2.648,2.648,0,0,1,2.111-.965,2.615,2.615,0,0,1,1.41.429Z",
    transform: "translate(-111.257 -28.135)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4196",
    "data-name": "Path 4196",
    d: "M246.065,28.52v5.254h-.825V28.52Z",
    transform: "translate(-112.351 -28.165)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4197",
    "data-name": "Path 4197",
    d: "M247.78,33.783V28.529h1.105a3.934,3.934,0,0,1,1.254.157,2.309,2.309,0,0,1,.9.52,2.516,2.516,0,0,1,.825,1.955,2.557,2.557,0,0,1-1.74,2.474,3.992,3.992,0,0,1-1.237.148h-1.1Zm.825-.751h.355a3.035,3.035,0,0,0,.891-.115,1.9,1.9,0,0,0,.643-.379,1.971,1.971,0,0,0-.058-2.8,2.177,2.177,0,0,0-1.534-.478h-.355v3.778Z",
    transform: "translate(-112.796 -28.167)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4198",
    "data-name": "Path 4198",
    d: "M256.572,32.435H254.32l-.586,1.278h-.825l2.549-5.584,2.474,5.584h-.825Zm-.33-.742-.784-1.79-.825,1.79Z",
    transform: "translate(-113.694 -28.097)",
    fill: "#7e739a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4199",
    "data-name": "Path 4199",
    d: "M262.785,29.284l-.643.379a1.138,1.138,0,0,0-.346-.412.907.907,0,0,0-.982.082.577.577,0,0,0-.214.462q0,.379.569.619l.528.214a2.186,2.186,0,0,1,.94.635,1.419,1.419,0,0,1,.3.916,1.6,1.6,0,0,1-.487,1.2,1.779,1.779,0,0,1-2.342.074,1.814,1.814,0,0,1-.544-1.138l.825-.173a1.386,1.386,0,0,0,.19.643.877.877,0,0,0,1.584-.536,1,1,0,0,0-.041-.28.642.642,0,0,0-.132-.231.915.915,0,0,0-.231-.2,2.143,2.143,0,0,0-.338-.181l-.5-.214a1.468,1.468,0,0,1-1.08-1.336,1.254,1.254,0,0,1,.454-.99,1.65,1.65,0,0,1,1.13-.4,1.559,1.559,0,0,1,1.369.874Z",
    transform: "translate(-114.86 -28.146)",
    fill: "#7e739a"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbpd);
export default __webpack_public_path__ + "static/media/ubpd.faf5a5070872851d21d06856f9e33473.svg";
export { ForwardRef as ReactComponent };